import React, { Component } from 'react';

class ShowPDF extends Component{

    constructor(props){
        super(props);
        this.state={
            pdf_pages:null
        }
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({pdf_pages:numPages})
    }



    render(){

        let width = window.innerWidth - 40

        const options = {
            cMapUrl: 'cmaps/',
            cMapPacked: true,
          };

        return(<div></div>
        )
    }
}


export default ShowPDF


// WEBPACK FOOTER //
// ./src/components/unused-components/show-pdf-component.js